import * as React from 'react';
import { Header } from './base';
import { action, observable, makeObservable } from 'mobx';
import { MembershipPlanIndexView, MembershipPlanKey } from '../../../types/membershipPlans';
import { RemoteResourceV3, updateRemoteResourceV3 } from '../../../../commonv3/api/RemoteResourceV3';
import { PlanView } from '../trial/plan/PlanSelector';
import './pricingSection.module.scss';
import { MembershipPlanApis } from '../../../apis/membershipPlans';
import { observer } from 'mobx-react';
import { EntranceFeeShowView } from '../../../types/entranceFees';
import { EntranceFeeApis } from '../../../apis/entranceFees';
import { EntranceFeeView } from '../trial/plan/EntranceFeeView';

export const PricingSection = observer(
  class PricingSection extends React.Component {
    selectedKey = MembershipPlanKey.REGULAR;
    plans: RemoteResourceV3<MembershipPlanIndexView[]> = RemoteResourceV3.loading();
    entranceFee: RemoteResourceV3<EntranceFeeShowView> = RemoteResourceV3.loading();

    constructor(props) {
      super(props);

      makeObservable(this, {
        selectedKey: observable,
        plans: observable,
        entranceFee: observable,
        init: action.bound,
      });
    }

    componentDidMount(): void {
      this.init();
    }

    async init() {
      await Promise.all([
        updateRemoteResourceV3(
          this.plans,
          (v) => (this.plans = v),
          () => MembershipPlanApis.findAll(true)
        ),
        updateRemoteResourceV3(
          this.entranceFee,
          (v) => (this.entranceFee = v),
          () => EntranceFeeApis.show(true)
        ),
      ]);
    }
    render() {
      return (
        <div styleName="section">
          <Header>料金体系について</Header>
          <div styleName="body">
            <PlanView
              selectedKey={this.selectedKey}
              onSelectKeyChange={(key) => (this.selectedKey = key)}
              plans={this.plans.getOrElse([])}
            />
            <EntranceFeeView
              price={this.entranceFee.map((e) => e.price).getOrElse(0)}
              price_with_tax={this.entranceFee.map((e) => e.price_with_tax).getOrElse(0)}
            />
          </div>
        </div>
      );
    }
  }
);
